var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOptionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#128BAB",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.875C20.6508 32.875 17.125 29.3492 17.125 25C17.125 20.6508 20.6508 17.125 25 17.125C29.3492 17.125 32.875 20.6508 32.875 25C32.875 29.3492 29.3492 32.875 25 32.875ZM25 34C29.9706 34 34 29.9706 34 25C34 20.0294 29.9706 16 25 16C20.0294 16 16 20.0294 16 25C16 29.9706 20.0294 34 25 34Z",
    fill: "#128B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.5C25.3107 20.5 25.5625 20.7518 25.5625 21.0625V24.4375H28.9375C29.2482 24.4375 29.5 24.6893 29.5 25C29.5 25.3107 29.2482 25.5625 28.9375 25.5625H25.5625V28.9375C25.5625 29.2482 25.3107 29.5 25 29.5C24.6893 29.5 24.4375 29.2482 24.4375 28.9375V25.5625H21.0625C20.7518 25.5625 20.5 25.3107 20.5 25C20.5 24.6893 20.7518 24.4375 21.0625 24.4375H24.4375V21.0625C24.4375 20.7518 24.6893 20.5 25 20.5Z",
    fill: "#128B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOptionButton);
export default __webpack_public_path__ + "static/media/add-option-button.983283cf6d7280ad8981d28e5d6dfc89.svg";
export { ForwardRef as ReactComponent };